<template>
  <basic-layout-dynamic :hide-footer="true">
    <div class="container">
      <div class="md-tabs-badge-wrapper">
        <md-tabs :md-active-tab="activeTab" @md-changed="selectTab">
          <md-tab id="history" md-label="分析履歴" md-icon="history"></md-tab>
          <md-tab
            v-if="$store.getters.isDeveloper"
            id="reservation"
            md-label="分析予約"
            md-icon="schedule"
          ></md-tab>
        </md-tabs>
        <div
          v-if="hasActionRequiredReservation && $store.getters.isDeveloper"
          class="tab-badge"
        >
          !
        </div>
      </div>
      <!-- 分析履歴 -->
      <transition :name="transitionName" mode="out-in">
        <div
          v-if="activeTab === 'history'"
          key="history"
          class="display-flex direction-column"
        >
          <div class="contents">
            <!-- 履歴一覧表示条件 -->
            <md-card v-if="$store.getters.isDeveloper">
              <md-card-header>
                <div class="md-title animated">
                  {{ '表示条件' }}
                </div>
              </md-card-header>
              <md-card-content>
                <!-- 履歴表示フィルター：即時実行と予約実行の表示切り替え -->
                <div class="direction-row" style="height: 60px">
                  <div class="direction-column" style="height: 40px">
                    <md-checkbox
                      v-model="queryHistoryConditions.includeImmediate"
                      :label="'即時実行の履歴を表示する'"
                      >即時実行の履歴を表示
                    </md-checkbox>
                    <md-checkbox
                      v-model="queryHistoryConditions.includeReserve"
                      :label="'予約実行の履歴を表示する'"
                      >予約実行の履歴を表示
                    </md-checkbox>
                  </div>
                  <span
                    v-show="!isQueryHistorySearchAvailable"
                    class="warn-text"
                  >
                    ※最低1つはチェックを入れてください</span
                  >
                </div>
              </md-card-content>
            </md-card>
            <div class="refresh-button search-button">
              <gl-button
                dense
                primary
                :disabled="!isQueryHistorySearchAvailable"
                icon-pre="refresh"
                class="button-group__button"
                @click="reloadQueryHistory"
                >再検索
              </gl-button>
            </div>
          </div>
          <div class="contents">
            <query-management-table
              ref="historyTable"
              v-bind:data-type="'history'"
              v-bind:rows="queryHistoryRows"
              v-bind:columns="_queryHistoryColumns"
              v-bind:loading="loading"
              @row-selected="onRowSelected"
            ></query-management-table>
          </div>
        </div>
        <div
          v-else-if="activeTab === 'reservation'"
          key="reservation"
          class="display-flex direction-column"
        >
          <!-- 予約一覧表示条件 -->
          <div class="contents">
            <md-card>
              <md-card-header>
                <div class="md-title animated">
                  {{ '表示条件' }}
                </div>
              </md-card-header>
              <md-card-content>
                <md-checkbox
                  v-model="queryReservationConditions.includeFinished"
                  :label="'実行済みの予約も表示する'"
                  >実行済みの予約も表示する
                </md-checkbox>
              </md-card-content>
            </md-card>
            <div class="refresh-button search-button">
              <gl-button
                dense
                primary
                icon-pre="refresh"
                class="button-group__button"
                @click="reloadQueryReservation"
                >再検索
              </gl-button>
            </div>
          </div>
          <div class="contents">
            <query-management-table
              ref="reservationTable"
              v-bind:data-type="'reservation'"
              v-bind:rows="queryReservationRows"
              v-bind:columns="queryReservationColumns"
              v-bind:loading="loading"
              @row-selected="onRowSelected"
            ></query-management-table>
          </div>
        </div>
      </transition>
      <!-- 条件項目一覧（サイドパネル） -->
      <transition name="panel-slide">
        <div
          v-if="showFilterPanel"
          class="filter-panel-overlay"
          @click="closeFilterPanel"
        >
          <div class="filter-panel" @click.stop>
            <div class="filter-panel-header">
              <button class="panel-close" @click="closeFilterPanel">
                <md-icon>close</md-icon>
              </button>
            </div>
            <div class="filter-panel-content">
              <gl-summary-query-filter
                v-if="activeTab === 'history'"
                v-bind:selectedRow="queryHistorySelected"
                v-bind:queryState="queryHistoryState"
                v-bind:handleSubmit="handleSubmit"
                :active-tab="activeTab"
              />
              <gl-summary-query-filter
                v-else-if="activeTab === 'reservation'"
                v-bind:selectedRow="queryReservationSelected"
                v-bind:queryState="queryReservationState"
                v-bind:handleSubmit="handleSubmit"
                :delete-reservation="handleDeleteReservation"
                :close-reservation="handleCloseReservation"
                :pause-reservation="handlePauseReservation"
                :active-tab="activeTab"
              />
            </div>
          </div>
        </div>
      </transition>
    </div>
  </basic-layout-dynamic>
</template>

<script>
import QueryManagementTable from '@/components/QueryManagementTable.vue'
import GlSummaryQueryFilter from '@/components/GlSummaryQueryFilter.vue'
import moment from 'moment'
import {
  canEditReservation,
  canResubmitReservation,
} from '@/const/statusConfig'
export default {
  components: {
    QueryManagementTable,
    GlSummaryQueryFilter,
  },
  data() {
    return {
      /**
       * 選択されているタブ（分析条件:filter or 分析結果:result）
       */
      activeTab: 'history',
      previousTab: 'history',
      // 分析履歴一覧データ
      queryHistoryRows: [],
      // 選択中の分析履歴行
      queryHistorySelected: undefined,
      // 分析履歴を表示する条件
      queryHistoryConditions: {
        // 即時実行の履歴を表示するか
        includeImmediate: true,
        // 予約実行の履歴を表示するか
        // TODO: (isDeveloper)[一般ユーザーにも予約機能を公開する際に復元] 元々は'true'
        includeReserve: this.$store.getters.isDeveloper,
      },
      // 分析履歴一覧カラム
      queryHistoryColumns: [
        {
          label: '',
          data: 'status',
          isIcon: true,
          style: {
            textAlign: 'center',
            width: '60px',
          },
        },
        {
          label: '実行日',
          data: 'startedAt',
          isCustom: false,
          isIcon: false,
          style: {
            width: '180px',
            minWidth: '150px',
          },
        },
        {
          label: 'サービス',
          data: 'menuDataType',
          isCustom: true,
          isIcon: false,
          style: {
            width: '100px',
            minWidth: '60px',
          },
          render: (h, item) => {
            let dataTypeColor = ''

            switch (item.menuDataType) {
              case 'ID-POS':
                dataTypeColor = '#40c4ff'
                break
              case 'POS':
                dataTypeColor = '#f8aa37'
                break
              default:
                break
            }

            return h(
              'span',
              {
                style: {
                  fontSize: 'smaller',
                  border: `2px solid ${dataTypeColor}`,
                  padding: '3px',
                  borderRadius: '5px',
                  color: dataTypeColor,
                  fontWeight: 'bold',
                },
              },
              item.menuDataType,
            )
          },
        },
        {
          label: 'メニュー',
          data: 'menuName',
          isCustom: true,
          isIcon: false,
          style: {
            width: '250px',
            minWidth: '180px',
          },
          render: (h, item) => {
            // 「｛アバター｝{メニュー正式名}」の形にする
            return h('span', { attrs: { title: item.menuName } }, [
              h('md-avatar', {}, [
                h('img', {
                  attrs: {
                    src: item.menuImageUrl,
                    alt: item.menuLongName,
                  },
                  style: {
                    objectFit: 'cover',
                  },
                }),
              ]),
              h('span', { style: { marginLeft: '16px' } }, item.menuLongName),
            ])
          },
        },
        // TODO: (isDeveloper)[一般ユーザーにも予約機能を公開する際に削除] 本番検証後はここに分析タイトルを戻す。
        // // @memo 上で指定した列幅を保つための吸収役として、空列をWidht: 'auto'で追加するのもあり
      ],
      // 分析予約一覧データ
      queryReservationRows: [],
      // 選択中の分析予約行
      queryReservationSelected: undefined,
      // 予約一覧を表示する条件
      queryReservationConditions: {
        includeFinished: false,
      },
      // 分析予約一覧カラム
      queryReservationColumns: [
        {
          label: '',
          data: 'status',
          isIcon: true,
          style: {
            textAlign: 'center',
            width: '60px',
          },
        },
        {
          label: '実行予定日',
          data: 'scheduledDate',
          isCustom: false,
          isIcon: false,
          style: {
            width: '100px',
            minWidth: '100px',
          },
        },
        {
          label: '実行周期',
          data: 'cycleType',
          isCustom: true,
          isIcon: false,
          style: {
            width: '100px',
            minWidth: '80px',
          },
          render: (h, item) => {
            const cycleTypeMap = {
              ONCE: '今回のみ',
              WEEKLY: '毎週',
              MONTHLY: '毎月',
              MONTHLY_EXACT: '毎月',
            }
            const label = cycleTypeMap[item.cycleType] || item.cycleType
            return h(
              'span',
              {
                style: {
                  fontSize: 'smaller',
                  border: '2px solid #666',
                  backgroundColor: '#f5f5f5',
                  padding: '3px',
                  borderRadius: '5px',
                  color: '#333',
                  fontWeight: 'bold',
                },
              },
              label,
            )
          },
        },
        {
          label: 'サービス',
          data: 'menuDataType',
          isCustom: true,
          isIcon: false,
          style: {
            width: '100px',
            minWidth: '60px',
          },
          render: (h, item) => {
            let dataTypeColor = ''
            switch (item.menuDataType) {
              case 'ID-POS':
                dataTypeColor = '#40c4ff'
                break
              case 'POS':
                dataTypeColor = '#f8aa37'
                break
              default:
                break
            }
            return h(
              'span',
              {
                style: {
                  fontSize: 'smaller',
                  border: `2px solid ${dataTypeColor}`,
                  padding: '3px',
                  borderRadius: '5px',
                  color: dataTypeColor,
                  fontWeight: 'bold',
                },
              },
              item.menuDataType,
            )
          },
        },
        {
          label: 'メニュー',
          data: 'menuName',
          isCustom: true,
          isIcon: false,
          style: {
            width: '250px',
            minWidth: '180px',
          },
          render: (h, item) => {
            // 「｛アバター｝{メニュー正式名}」の形にする
            return h('span', { attrs: { title: item.menuName } }, [
              h('md-avatar', {}, [
                h('img', {
                  attrs: {
                    src: item.menuImageUrl,
                    alt: item.menuLongName,
                  },
                  style: {
                    objectFit: 'cover',
                  },
                }),
              ]),
              h('span', { style: { marginLeft: '16px' } }, item.menuLongName),
            ])
          },
        },
        {
          label: '分析タイトル',
          data: 'title',
          isCustom: false,
          isIcon: false,
          style: {
            width: 'auto',
            minWidth: '150px',
          },
        },
        // // @memo 上で指定した列幅を保つための吸収役として、空列をWidht: 'auto'で追加するのもあり
      ],
      // ロードステータス
      loading: true,
      // フィルタパネルの表示状態
      showFilterPanel: false,
      // ユーザーが処理する必要がある予約の状態
      hasActionRequiredReservation: false,
    }
  },
  computed: {
    /**
     * タブの移動方向に合わせたトランジション名
     */
    transitionName() {
      const tabOrder = ['history', 'reservation']
      const currentIndex = tabOrder.indexOf(this.activeTab)
      const previousIndex = tabOrder.indexOf(this.previousTab)

      return currentIndex > previousIndex ? 'tab-slide-right' : 'tab-slide-left'
    },
    /**
     * 選択行に対して遷移権限があるか
     */
    hasPermissionReservation() {
      if (!this.queryReservationSelected) return false
      // 現在の所属企業
      const authorizedCompanyCodes = this.$store.state.companies.map(
        m => m.code,
      )
      // 選択した分析予約の条件に含まれる企業コード（companyから始まるプロパティすべて）
      const selectedCompanies = this.collectCompanyCodes(
        this.queryReservationSelected.queryFilter,
      )
      // 現在の所属企業の中にあるか
      const companyCodePermission = selectedCompanies.every(code =>
        authorizedCompanyCodes.includes(code),
      )

      // ID-POS、POSの契約があるか検証
      // 現在の契約メニュー
      const menus = this.$store.state.menus
      // 選択している分析予約のメニュー
      const selectedMenu = this.queryReservationSelected.menu
      const menuPermission = menus.some(s => {
        return s.menuCode === selectedMenu
      })

      // 予約が編集・再実行可能な状態かどうか（RequiresUpdate/Waiting/Pausedなら遷移可能）
      const statusPermission =
        canEditReservation(this.queryReservationSelected.status) ||
        canResubmitReservation(this.queryReservationSelected.status)
      return companyCodePermission && menuPermission && statusPermission
    },
    /**
     * 履歴側での遷移権限
     */
    hasPermissionHistory() {
      if (!this.queryHistorySelected) return false
      // 現在の所属企業
      const authorizedCompanyCodes = this.$store.state.companies.map(
        m => m.code,
      )
      // 選択した分析履歴の条件に含まれる企業コード（companyから始まるプロパティすべて）
      const selectedCompanies = this.collectCompanyCodes(
        this.queryHistorySelected.queryFilter,
      )
      // 現在の所属企業の中にあるか
      const companyCodePermission = selectedCompanies.every(code =>
        authorizedCompanyCodes.includes(code),
      )

      // ID-POS、POSの契約があるか検証
      // 現在の契約メニュー
      const menus = this.$store.state.menus
      // 選択している分析履歴のメニュー
      const selectedMenu = this.queryHistorySelected.menu
      const menuPermission = menus.some(s => {
        return s.menuCode === selectedMenu
      })

      // エラーが起きた行ではないか検証
      const errorPermission = !this.queryHistorySelected.error
      return companyCodePermission && menuPermission && errorPermission
    },
    // TODO: [一般ユーザーにも予約機能を公開する際に削除] 分析タイトルはdataの部分に戻す。
    _queryHistoryColumns() {
      if (this.$store.getters.isDeveloper) {
        const ret = [...this.queryHistoryColumns]
        ret.push({
          label: '分析タイトル',
          data: 'title',
          isCustom: false,
          isIcon: false,
          style: {
            width: 'auto',
            minWidth: '150px',
          },
        })
        return ret
      }
      return this.queryHistoryColumns
    },
    /**
     * 分析履歴側のクエリ状態
     */
    queryHistoryState() {
      if (!this.queryHistorySelected) return 'disabled'
      // 分析済み＆権限あり＆エラーなし → 分析結果確認可能
      if (this.queryHistorySelected.queryId && this.hasPermissionHistory) {
        return 'result-available'
      }
      return 'disabled'
    },
    /**
     * 予約履歴側のクエリ状態
     */
    queryReservationState() {
      if (!this.queryReservationSelected) return 'disabled'
      // 分析完了＆1週間以内＆権限あり → 分析結果確認可能
      if (
        this.queryReservationSelected.queryId &&
        this.queryReservationSelected.status === 'Completed' &&
        this.queryReservationSelected.startedAt &&
        moment(this.queryReservationSelected.startedAt).isSameOrAfter(
          moment().subtract(7, 'days'),
        ) &&
        this.hasPermissionReservation
      ) {
        return 'result-available'
      }
      // 分析条件を再利用可能 → 分析条件を再利用する
      // (完了＆1週間以上、またはエラーで、分析条件を再利用)
      if (
        this.hasPermissionReservation &&
        ((this.queryReservationSelected.status === 'Completed' &&
          this.queryReservationSelected.startedAt &&
          moment(this.queryReservationSelected.startedAt).isBefore(
            moment().subtract(7, 'days'),
          )) ||
          this.queryReservationSelected.status === 'Error' ||
          this.queryReservationSelected.status === 'NextReservationFailed')
      ) {
        return 'reuse-available'
      }
      // 予約条件が編集可能 → 予約条件編集可能
      // (未実行：Waiting/Paused/RequiresUpdate/NextReservationFailed)
      if (
        canEditReservation(this.queryReservationSelected.status) &&
        this.hasPermissionReservation
      ) {
        return 'edit-available'
      }
      return 'disabled'
    },
    /**
     * menuCodeをキーとしたメニュー情報の辞書
     */
    menuByCode() {
      return this.$store.state.menus.reduce((acc, menu) => {
        acc[menu.menuCode] = menu
        return acc
      }, {})
    },
    /**
     * 履歴タブでの検索条件が有効かどうか
     */
    isQueryHistorySearchAvailable() {
      return (
        this.queryHistoryConditions.includeImmediate ||
        this.queryHistoryConditions.includeReserve
      )
    },
  },
  watch: {
    activeTab(newVal, oldVal) {
      this.previousTab = oldVal
    },
  },
  mounted() {
    const openParams = this.$route.query.reservationMode
    if (openParams) {
      this.activeTab = 'reservation'
    }

    // ユーザーが処理する必要がある予約の状態を取得
    this.fetchActionRequiredReservationStatus()
  },
  methods: {
    /**
     * タブ選択
     */
    selectTab(event) {
      this.activeTab = event
      // タブ切替時に行選択をリセット
      this.queryHistorySelected = undefined
      this.queryReservationSelected = undefined

      this.$nextTick(() => {
        window.dispatchEvent(new Event('resize'))
      })
    },
    /**
     * 選択タブの行選択コンフィグを返す
     */
    getRowSelectionConfig() {
      const selectionConfigByTab = {
        history: {
          selectedKey: 'queryHistorySelected',
          repositoryName: 'queryLog',
          rowIdKey: 'queryId',
        },
        reservation: {
          selectedKey: 'queryReservationSelected',
          repositoryName: 'queryReservation',
          rowIdKey: 'reservationId',
        },
      }

      return selectionConfigByTab[this.activeTab]
    },
    /**
     * 行選択されたときの処理
     */
    async onRowSelected(row) {
      const selectionConfig = this.getRowSelectionConfig()
      if (!selectionConfig) {
        return
      }

      // 一度選択された行はテーブルが更新されない限り保持されるので、
      // すでに分析条件がセットされている場合は再取得しない。
      if (!row) {
        if (this.activeTab === 'history') {
          this.queryHistorySelected = undefined
        } else if (this.activeTab === 'reservation') {
          this.queryReservationSelected = undefined
        }
        return
      }
      // 分析条件が未セットなら取得
      if (!row.queryFilter) {
        const queryFilter = await this.$repositories
          .get(selectionConfig.repositoryName)
          .getQueryFilter(row[selectionConfig.rowIdKey])
        row.queryFilter = queryFilter
      }
      // 選択された行をセット
      if (this.activeTab === 'history') {
        this.queryHistorySelected = row
      } else if (this.activeTab === 'reservation') {
        this.queryReservationSelected = row
      }
      // パネルを表示
      if (row) {
        this.showFilterPanel = true
      }
    },
    /**
     * 分析条件詳細から画面への遷移ボタン
     */
    handleSubmit() {
      const baseUrl = process.env.BASE_URL
      switch (this.activeTab) {
        case 'history': {
          const { menu, queryId } = this.queryHistorySelected
          window.open(`${baseUrl}query-${menu}/${queryId}`)
          break
        }
        case 'reservation': {
          const { menu, queryId, reservationId } = this.queryReservationSelected
          // queryStateに基づいて遷移先を変更
          if (this.queryReservationState === 'result-available') {
            // 分析結果確認可能な場合は結果画面に遷移
            window.open(`${baseUrl}query-${menu}/${queryId}`)
          } else {
            // 予約条件編集可能 or 条件再利用 の場合は予約画面に遷移
            window.open(`${baseUrl}query-${menu}?reservation=${reservationId}`)
          }
          break
        }
        default:
          break
      }
    },
    /**
     * リロードボタン（履歴）
     */
    async reloadQueryHistory() {
      this.queryHistoryRows = []
      this.queryHistorySelected = undefined
      await this.getQueryHistory()
      this.loading = false
    },
    /**
     * 一覧情報を更新する(履歴)
     */
    async getQueryHistory() {
      this.loading = true
      const immediate = this.queryHistoryConditions.includeImmediate
      const reserve = this.queryHistoryConditions.includeReserve
      let queryHistoryRows = await this.$repositories
        .get('queryLog')
        .getQueryHistoryRows(immediate, reserve)
      this.queryHistoryRows = queryHistoryRows.map(row => this.getMenuInfo(row))
    },
    /**
     * リロードボタン(予約)
     */
    async reloadQueryReservation() {
      this.queryReservationRows = []
      this.queryReservationSelected = undefined
      await this.getQueryReservation()
      this.loading = false
    },
    /**
     * 画面の情報を更新する(予約)
     */
    async getQueryReservation() {
      this.loading = true
      const finished = this.queryReservationConditions.includeFinished
      let queryReservationRows = await this.$repositories
        .get('queryReservation')
        .getQueryReservationRows(finished)
      this.queryReservationRows = queryReservationRows.map(row => {
        let formattedRow = row
        formattedRow = this.getMenuInfo(row)
        formattedRow = {
          ...formattedRow,
          scheduledDate: formattedRow.scheduledDate
            ? moment(formattedRow.scheduledDate, 'YYYYMMDD').format(
                'YYYY-MM-DD',
              )
            : '',
        }
        return formattedRow
      })
    },
    /**
     * 予約を削除する
     * @param {string} reservationId - 削除対象の予約ID
     * @description 指定した予約IDの予約を削除し、成功時は一覧をリロードして選択状態をクリア
     */
    async handleDeleteReservation(reservationId) {
      const deletedReservationId = await this.$repositories
        .get('queryReservation')
        .deleteReservation(reservationId)
      // 削除成功後は選択状態をクリアしてリロード
      if (deletedReservationId) {
        this.queryReservationSelected = undefined
        await this.getQueryReservation()
        await this.fetchActionRequiredReservationStatus()
      }
      this.closeFilterPanel()
      this.loading = false
    },
    /**
     * 予約を対応済みとして終了する
     * @param {string} reservationId - 対応済み処理を行う予約ID
     * @description 「NextReservationFailed」（次回予約失敗）の予約を終了し、一覧をリロード
     */
    async handleCloseReservation(reservationId) {
      await this.$repositories
        .get('queryReservation')
        .closeReservation(reservationId)
      // 対応済み処理成功後は選択状態をクリアしてリロード
      this.queryReservationSelected = undefined
      await this.getQueryReservation()
      await this.fetchActionRequiredReservationStatus()
      this.loading = false
      this.closeFilterPanel()
    },
    /**
     * 予約を一時停止する
     * @param {string} reservationId - 一時停止対象の予約ID
     * @description 実行待機中の予約を一時停止状態にして、一覧をリロード
     */
    async handlePauseReservation(reservationId) {
      await this.$repositories
        .get('queryReservation')
        .pauseReservation(reservationId)
      // 一時停止成功後は選択状態をクリアしてリロード
      this.queryReservationSelected = undefined
      await this.getQueryReservation()
      this.loading = false
      this.closeFilterPanel()
    },
    /**
     * メニューに関する情報を入れて返す
     */
    getMenuInfo(row) {
      const menu = this.menuByCode[row.menu]
      return {
        ...row,
        menuName: menu ? menu.menuName : '',
        menuLongName: menu ? menu.menuLongName : '',
        menuImageUrl: menu ? menu.imageUrl : '',
        menuDataType: menu ? menu.dataType : '',
      }
    },
    /**
     * 現在参照可能な企業コード
     */
    collectCompanyCodes(obj) {
      let companies = []
      for (const key in obj) {
        const val = obj[key]
        if (key.startsWith('company') && typeof val === 'string') {
          companies.push(obj[key])
        }
        if (typeof val === 'object' && val !== null) {
          companies = companies.concat(this.collectCompanyCodes(val))
        }
      }
      return companies
    },
    closeFilterPanel() {
      this.showFilterPanel = false
      this.queryHistorySelected = undefined
      this.queryReservationSelected = undefined
      // テーブルの選択をクリア
      if (this.$refs.historyTable && this.$refs.historyTable.clearSelection) {
        this.$refs.historyTable.clearSelection()
      }
      if (
        this.$refs.reservationTable &&
        this.$refs.reservationTable.clearSelection
      ) {
        this.$refs.reservationTable.clearSelection()
      }
    },
    /**
     * ユーザーが処理する必要がある予約の状態を取得
     */
    async fetchActionRequiredReservationStatus() {
      try {
        const hasActionRequired = await this.$repositories
          .get('queryReservation')
          .hasActionRequiredReservation()
        // TODO: [一般ユーザーにも予約機能を公開する際に削除] isDeveloper チェック
        this.hasActionRequiredReservation =
          hasActionRequired && this.$store.getters.isDeveloper
      } catch (e) {
        this.hasActionRequiredReservation = false
      }
    },
  },
  async created() {
    await this.getQueryHistory()
    await this.getQueryReservation()
    this.loading = false
  },
}
</script>

<style lang="scss" scoped>
/* メインコンテナ：タブと一覧テーブルを縦方向に配置 */
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  /* ヘッダー高さ 72px を除いたウィンドウ全体の高さから、さらに 72px を除く */
  height: calc(100vh - 144px);
  overflow-x: hidden;
}

/* md-tabs とバッジを囲むwrapper：中央寄せと相対位置指定 */
.md-tabs-badge-wrapper {
  display: flex;
  justify-content: center;
  width: fit-content;
  position: relative;
}

/* 条件セクション・テーブルセクションのコンテナ */
.contents {
  width: 80%;
  min-width: 600px;
  margin-top: var(--spacing-small);
  position: relative;

  /* テーブル用の contents（最後の子要素）を残りのスペース全体に拡張 */
  &:last-child {
    height: 0;
    flex: 1;
    margin-top: var(--spacing-small);
  }
}

/* flex コンテナ（行・列の方向は direction-* で指定） */
.display-flex {
  width: 100%;
  min-height: 0;
  display: flex;
  position: relative;
  margin-top: var(--spacing-small);
}

/* 横方向に要素を並べるレイアウト */
.direction-row {
  flex-direction: row;
  gap: var(--spacing-small);
}

/* 縦方向に要素を並べるレイアウト */
.direction-column {
  flex-direction: column;
  align-items: center;
}

/* 更新ボタンの配置 */
.refresh-button {
  display: flex;
  justify-content: flex-end;
  margin-bottom: var(--spacing-small);
  position: absolute;
  right: calc(var(--spacing-small));
}

/* 検索・リロードボタンの位置 */
.search-button {
  bottom: var(--spacing-small);
}

/* 分析予約タブのアクション必須バッジ */
.tab-badge {
  position: absolute;
  z-index: 29;
  top: 8px;
  right: 8px;
  width: 14px;
  height: 14px;
  background: var(--color-warn);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: bold;
  box-shadow: 0 0 0 2px white;
}

/* 警告テキストのスタイル */
.warn-text {
  color: var(--color-warn);
  font-size: var(--font-size-medium);
}

/* 右方向へのタブスライドトランジション（エンター時） */
.tab-slide-right-enter-active,
.tab-slide-right-leave-active {
  transition: all 0.2s ease-in-out;
}

/* 右方向へスライド：エンター状態 */
.tab-slide-right-enter {
  opacity: 0;
  transform: translateX(50px);
}

/* 右方向へスライド：リーブ時 */
.tab-slide-right-leave-to {
  opacity: 0;
  transform: translateX(-50px);
}

/* 左方向へのタブスライドトランジション（エンター時） */
.tab-slide-left-enter-active,
.tab-slide-left-leave-active {
  transition: all 0.2s ease-in-out;
}

/* 左方向へスライド：エンター状態 */
.tab-slide-left-enter {
  opacity: 0;
  transform: translateX(-50px);
}

/* 左方向へスライド：リーブ時 */
.tab-slide-left-leave-to {
  opacity: 0;
  transform: translateX(50px);
}

/* フィルタ条件パネルのオーバーレイ背景 */
.filter-panel-overlay {
  position: fixed;
  inset: 72px 0 0 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 30;
  display: flex;
  justify-content: flex-end;
}

/* フィルタ条件パネル本体 */
.filter-panel {
  background: #fff;
  width: 640px;
  max-width: 90vw;
  height: 100%;
  padding: 0;
  overflow: hidden;
  position: relative;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
}

/* フィルタパネルのヘッダーエリア */
.filter-panel-header {
  flex-shrink: 0;
  padding: 6px 12px;
  min-height: 40px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

/* フィルタパネルのコンテンツエリア */
.filter-panel-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

/* パネルクローズボタン */
.panel-close {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  min-width: 0;
}

/* パネルスライドトランジション（フェードイン・フェードアウト） */
.panel-slide-enter-active,
.panel-slide-leave-active {
  transition: opacity 0.3s ease-in-out;
}

/* パネルスライド：透明度の変化 */
.panel-slide-enter,
.panel-slide-leave-to {
  opacity: 0;
}

/* パネルスライド：パネル本体の横方向移動 */
.panel-slide-enter .filter-panel,
.panel-slide-leave-to .filter-panel {
  transform: translateX(100%);
}

/* パネルスライド：パネル本体の移動トランジション */
.panel-slide-enter-active .filter-panel,
.panel-slide-leave-active .filter-panel {
  transition: transform 0.3s ease-in-out;
}
</style>
